export default __webpack_public_path__ + "static/media/open-eye.8d32c5df.svg";